import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@/styles/globals.css'
import App from './App.tsx'
import { ErrorBoundary } from '@/components/ErrorBoundary'
import { captureAuthUrlOnce } from '@/lib/authUrlSession'

// S3b: capture + scrub URL auth parameters BEFORE the router reads the
// location, so no router state / history.state ever holds them.
captureAuthUrlOnce()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
)
